import React from 'react'
import Layout from '../components/Layouts/Layout'

const PageNotFound = () => {
  return (
    <Layout title={"Page Not Found :("}>
        <h1> Page Not Found </h1>
    </Layout>
  )
}

export default PageNotFound
